import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
const checkout = 'https://esl-teacher-ready.impultienda.ar/checkout';
const productImage = 'https://cdn.magicpatterns.com/uploads/54HYaPXG7W1ch1GQdAuNUw/seguridad_e_higiene_(4).png';
export function Hero() {
  return <section id="inicio" className="relative overflow-hidden border-b border-line px-4 pb-16 pt-10 sm:pb-24 sm:pt-16" data-id="element-82">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_rgba(184,134,11,.22),_transparent_55%)]" data-id="element-83" />
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-85">
          <p className="inline-flex rounded-full border border-gold-700 bg-gold-700/15 px-3 py-1 text-xs font-bold tracking-wide text-gold-100" data-id="element-86">
            📚 ESL Teacher Ready™
          </p>
          <h1 className="mx-auto mt-5 max-w-4xl font-display text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl" data-id="element-87">
            Solve an entire year of lessons{' '}
            <span className="gold-text" data-id="element-88">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.12,
        duration: 0.65
      }} className="relative my-7 w-full max-w-md sm:max-w-lg" data-id="element-89">
          <div className="absolute inset-x-[15%] bottom-0 h-20 rounded-full bg-gold-500/30 blur-3xl" data-id="element-90" />
          <img src={productImage} alt="ESL Teacher Ready complete 6-in-1 teaching system" className="relative mx-auto w-full drop-shadow-2xl" data-id="element-91" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.24,
        duration: 0.5
      }} data-id="element-92">
          <p className="mx-auto max-w-2xl text-base leading-7 text-stone-300 sm:text-xl" data-id="element-93">
            ESL Teacher Ready™ — the complete 6-in-1 professional teaching
            system, ready to use from today.
          </p>
          <PrimaryButton href={checkout} className="mt-7" data-id="element-94">
            🟡 GET THE COMPLETE 6-IN-1 SYSTEM NOW
          </PrimaryButton>
          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone-400 sm:text-sm" data-id="element-95">
            {['Premium Teaching System', '5 Strategic Bonuses', 'Immediate Access'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-96">
                <CheckCircle2Icon size={15} className="text-gold-300" data-id="element-97" />
                {item}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}